import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { SessionStorageKey, SessionStorageState } from 'common';

@Injectable({
  providedIn: 'root',
})
export class IdVerseCompletedCallbackGuard implements CanActivate {
  constructor(
    private readonly router: Router,
  ) {}

  canActivate(): boolean {
    SessionStorageState.remove(SessionStorageKey.AccountSetupViewed);
    SessionStorageState.remove(SessionStorageKey.IdVerseCompletedCallback);
    SessionStorageState.set(SessionStorageKey.IdVerseCompletedCallback, true);

    this.router.navigateByUrl('home', { replaceUrl: true });
    return false;
  }
}